import { render, staticRenderFns } from "./ProjectAssistant.vue?vue&type=template&id=18dbc09a&scoped=true&"
import script from "./ProjectAssistant.vue?vue&type=script&lang=ts&"
export * from "./ProjectAssistant.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectAssistant.vue?vue&type=style&index=0&id=18dbc09a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dbc09a",
  null
  
)

export default component.exports